import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Checkbox from '../../../component/form/Checkbox';
import Grid from '../../../component/form/Grid';
import Label from '../../../component/form/Label';
import TextField from '../../../component/form/TextField';
import AddressBookAutocomplete from '../../../component/form/AddressBookAutocomplete';
import { ADDRESS_BOOK_CATEGORY } from '../../funeral/funeralConstants';
import ContactCardModal from '../../../component/form/ContactCardModal';
import ColumnLayout from '../../../component/ColumnLayout';
import InputAdornment from '@mui/material/InputAdornment';
import DisplayContact from '../../../component/bookings/DisplayContact';
import DocumentModal from '../../funeral/billing/documentModal/DocumentModal';
import FileUpload, { getFileName } from '../../../component/form/FileUpload';
import Table, { TableCell, TableHeaderCell, TableHeaderRow, TableRow } from '../../../component/form/Table';
import LinkButton from '../../../component/form/LinkButton';
import { ContactCard, ContactCardContainer } from '../../../component/form/ContactCard';
import { isRelatedObjectDefined } from '../../../util/bookable';
import PrimaryButton from '../../../component/form/PrimaryButton';
import { ContactsIcon } from '../../../component/IconIndex';

class Certification extends Component {
    state = {
        authorizedContactModalField: undefined,
        relatedPerson: undefined,
        editContact: undefined,
        documentModal: { open: false, document: null }
    };

    render() {
        const { form } = this.props;
        const { documentModal, editContact } = this.state;
        return (
            <Fragment>
                <DocumentModal
                    onClose={() => this.setState({ documentModal: { open: false, document: null } })}
                    open={!!documentModal.open}
                    form={form}
                    document={documentModal.document}
                />
                <ContactCardModal
                    onClose={() => this.setState({ editContact: undefined })}
                    open={!!editContact}
                    value={editContact}
                    onSubmit={this.onSubmitContactCard}
                />
                <ColumnLayout>
                    {this.renderFirstColumn()}
                    {this.renderSecondColumn()}
                </ColumnLayout>
            </Fragment>
        );
    }

    renderFirstColumn() {
        return (
            <Grid container spacing={2}>
                {this.renderFund()}
                {this.renderAuthorisedContacts()}
            </Grid>
        );
    }

    renderSecondColumn() {
        return (
            <Grid container spacing={2}>
                {this.renderLegacyDocuments()}
            </Grid>
        );
    }

    renderFund() {
        const { form } = this.props;
        const myKey = form.getField('FuneralFundCode') || null;
        return (
            <Grid bucket>
                <Grid pc={1}>
                    <Label text={'Funeral Fund'} />
                    <AddressBookAutocomplete
                        form={form}
                        name={'FuneralFundName'}
                        canSearchByKey={true}
                        categories={[ADDRESS_BOOK_CATEGORY.funeralFund]}
                        onSelect={(_, result) =>
                            form.setField({
                                FuneralFundName: result?.Name || '',
                                FuneralFundCode: result?.LegacyKey || ''
                            })
                        }
                    />
                </Grid>
                {!!myKey && (
                    <Grid pc={1}>
                        <DisplayContact contactKey={myKey} />
                    </Grid>
                )}
                <Grid pc={1}>
                    <Label text={'Contract Amount'} />
                    <Grid container item spacing={3}>
                        <Grid item xs>
                            <TextField
                                form={form}
                                name={'ContractAmount'}
                                type={'number'}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs>
                            <Checkbox label={'Travel Protection'} form={form} name={'TravelProtection'} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderLegacyDocuments() {
        const { form } = this.props;
        const legacyDocuments = form.getField('LegacyDocuments') || [];

        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Label>Legacy Documents</Label>
                </Grid>
                <Grid item xs={12}>
                    {legacyDocuments.length > 0 ? (
                        <Table className="no-responsive">
                            <TableHeaderRow>
                                <TableHeaderCell>ID</TableHeaderCell>
                                <TableHeaderCell>Filename</TableHeaderCell>
                                <TableHeaderCell>Size</TableHeaderCell>
                            </TableHeaderRow>
                            {legacyDocuments.map((obj, i) => (
                                <TableRow key={i} pad={true}>
                                    <TableCell>#{obj.ID}</TableCell>
                                    <TableCell>
                                        <LinkButton
                                            onClick={() =>
                                                this.setState({
                                                    documentModal: { open: true, document: obj }
                                                })
                                            }
                                            text={obj.Name}
                                        />
                                    </TableCell>
                                    <TableCell>{obj.Size}</TableCell>
                                </TableRow>
                            ))}
                        </Table>
                    ) : (
                        <i>No documents</i>
                    )}
                </Grid>
                <Grid item xs={12}>
                    {this.renderNewUpload()}
                </Grid>
            </Grid>
        );
    }

    renderNewUpload() {
        const { form } = this.props;

        return (
            <div>
                <FileUpload
                    label={'Upload Document'}
                    buttonOnly={true}
                    folderPath={`/documents/prearrangements/${form.getField('ID')}`}
                    onComplete={({ uploadFile }) => this.onFileUploaded(uploadFile)}
                />
            </div>
        );
    }

    renderAuthorisedContacts() {
        const { form, locked } = this.props;
        const AuthorisedContacts = form.getField('AuthorisedContacts') || [];
        return (
            <Grid bucket={true}>
                <Grid pc={1}>
                    <Label text={'Authorised Contacts'} />

                    {!!AuthorisedContacts.length ? (
                        <ContactCardContainer>
                            {AuthorisedContacts.map((obj, i) => (
                                <ContactCard
                                    contact={obj}
                                    key={i}
                                    onDelete={!locked && (() => this.onDeleteContact(i))}
                                    onEdit={
                                        !locked && isRelatedObjectDefined(obj) && (() => this.onEditContact(i, obj))
                                    }
                                />
                            ))}
                        </ContactCardContainer>
                    ) : (
                        <p style={{ marginTop: 6 }}>There are no authorised contacts.</p>
                    )}

                    <PrimaryButton forModal disabled={locked} onClick={() => this.onEditContact(undefined, undefined)}>
                        <ContactsIcon />
                        Add authorised contact...
                    </PrimaryButton>
                </Grid>
            </Grid>
        );
    }

    onFileUploaded(upload) {
        const { form } = this.props;
        const LegacyDocuments = form.getField('LegacyDocuments') || [];
        LegacyDocuments.push({
            ID: upload.id,
            AbsoluteLink: upload.AbsoluteLink,
            Name: getFileName(upload.filename),
            Size: 'Save to confirm'
        });
        form.setField({ LegacyDocuments });
    }

    onSubmitContactCard = contact => {
        const { form } = this.props;
        const AuthorisedContacts = (form ? form.getField('AuthorisedContacts') : null) || [];
        const existingContact = contact.ID !== undefined ? AuthorisedContacts.find(x => x.ID === contact.ID) : null;

        if (existingContact) {
            Object.assign(existingContact, contact);
        } else {
            AuthorisedContacts.push(contact);
        }
        form.setField({ AuthorisedContacts });
        this.setState({ editContact: undefined });
    };

    onDeleteContact = index => {
        const { form } = this.props;
        const AuthorisedContacts = (form ? form.getField('AuthorisedContacts') : null) || [];

        AuthorisedContacts.splice(index, 1);

        form.setField({ AuthorisedContacts });
    };

    onEditContact = (index, contact) => {
        //empty means new
        const editContact = contact
            ? { ...contact }
            : {
                  Name: '',
                  Role: [],
                  Phones: [],
                  Email: '',
                  AddressLine1: '',
                  AddressLine2: '',
                  Suburb: '',
                  Postcode: '',
                  Country: ''
              };
        this.setState({ editContact });
    };
}

const styles = () => ({
    alignWithFloatingLabel: {
        marginTop: 17
    },

    alignWithLabel: {
        marginTop: 10
    }
});

export default withStyles(styles)(Certification);
